<script setup lang="ts">
import { onMounted, onUpdated }                         from "vue";
import Container                                        from "../CommonComponents/Container.vue";
import ButtonToMainPage                                 from "../CommonComponents/ButtonToMainPage.vue";
import { addClass, findElem, removeClass, toggleClass } from "../../Utils/helpers";
import AppHead                                          from "../CommonComponents/AppHead.vue";
import ButtonHistoryList                                from "../CommonComponents/ButtonHistoryList.vue";
import ButtonLogout                                     from "../CommonComponents/ButtonLogout.vue";
import ButtonThemeColor                                 from "../CommonComponents/ButtonThemeColor.vue";
import { initFlowbite }                                 from 'flowbite';

type TypeProps = {
    title? : string,
    description? : string,
    meta_title? : string,
    meta_description? : string,
    robots? : string,
    success? : string,
    error? : string,
    headerClass? : string,
};

defineProps<TypeProps>();

const checkThemeColor = () : void => {
    // On page load or when changing themes, best to add inline in `head` to avoid FOUC
    if (localStorage.getItem('color-theme') === 'dark' || (!('color-theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
        // document.documentElement.classList.add('dark');
        addClass('dark', document.documentElement);
    } else {
        // document.documentElement.classList.remove('dark');
        removeClass('dark', document.documentElement);
    }
};

const changeThemeColor = () : void => {
    const themeToggleDarkIcon = <HTMLElement | null>findElem('#theme-toggle-dark-icon'),
        themeToggleLightIcon = <HTMLElement | null>findElem('#theme-toggle-light-icon');

    // Change the icons inside the button based on previous settings
    if (localStorage.getItem('color-theme') === 'dark' || (!('color-theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
        removeClass('hidden', themeToggleLightIcon);
    } else {
        addClass('hidden', themeToggleDarkIcon);
    }

    const themeToggleBtn = <HTMLElement | null>findElem('#theme-toggle');

    themeToggleBtn?.addEventListener('click', () : void => {
        // toggle icons inside button
        toggleClass('hidden', themeToggleDarkIcon);
        toggleClass('hidden', themeToggleLightIcon);

        // if set via local storage previously
        if (localStorage.getItem('color-theme')) {
            if (localStorage.getItem('color-theme') === 'light') {
                // document.documentElement.classList.add('dark');
                addClass('dark', document.documentElement);
                localStorage.setItem('color-theme', 'dark');
            } else {
                // document.documentElement.classList.remove('dark');
                removeClass('dark', document.documentElement);
                localStorage.setItem('color-theme', 'light');
            }

            // if NOT set via local storage previously
        } else {
            if (document.documentElement.classList.contains('dark')) {
                // document.documentElement.classList.remove('dark');
                removeClass('dark', document.documentElement);
                localStorage.setItem('color-theme', 'light');
            } else {
                // document.documentElement.classList.add('dark');
                addClass('dark', document.documentElement);
                localStorage.setItem('color-theme', 'dark');
            }
        }
    });
};

onMounted(() => {
    checkThemeColor();
    changeThemeColor();
    initFlowbite();
});

onUpdated(() => {
    checkThemeColor();
    changeThemeColor();
    initFlowbite();
});
</script>

<template>
    <AppHead v-bind="$props"/>

    <div class="wrapper flex flex-col min-h-full">
        <header :class="['header', headerClass]" id="header">
            <Container>
                <div class="flex items-center justify-between flex-wrap gap-3">
                    <ButtonThemeColor></ButtonThemeColor>

                    <slot name="header-top"></slot>

                    <div v-if="$page.props.is_logged"
                         class="flex items-center flex-wrap gap-3">

                        <template v-if="!$page.props.is_main_page">
                            <ButtonToMainPage></ButtonToMainPage>
                        </template>

                        <template v-if="!$page.props.is_history_page && $page.props.is_has_history">
                            <ButtonHistoryList></ButtonHistoryList>
                        </template>

                        <ButtonLogout></ButtonLogout>
                    </div>
                </div>
            </Container>
        </header>

        <main class="main flex-auto">
            <slot name="main"></slot>
        </main>

        <footer class="footer">
            <slot name="footer"></slot>
        </footer>
    </div>
</template>
